module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "fullscreen-element no-pad centered-text",
    attrs: {
      "id": "top"
    }
  }, [(_vm.page == 'home') ? _c('div', {
    staticClass: "container masthead-container masthead-container-home"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left"
  }, [_c('div', {
    staticClass: "masthead-inner",
    attrs: {
      "id": "home-masthead"
    }
  }, [_c('div', {
    staticClass: "masthead-logo desktop"
  }, [_c('img', {
    attrs: {
      "src": 'static/img/common/logo.png'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-image-1"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'home/' + _vm.home.lockup.lockup_1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-image-2"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'home/' + _vm.home.lockup.lockup_2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-image-3"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'home/' + _vm.home.lockup.lockup_3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-text"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'home/' + _vm.home.lockup.text_img
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.page == 'food') ? _c('div', {
    staticClass: "container masthead-container masthead-container-food"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left"
  }, [_c('div', {
    staticClass: "masthead-inner"
  }, [_c('div', {
    staticClass: "masthead-image masthead-image-1"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'food/' + _vm.food.lockup.lockup_1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-image-2"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'food/' + _vm.food.lockup.lockup_2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-image-3"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'food/' + _vm.food.lockup.lockup_3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-text"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'food/' + _vm.food.lockup.text_img
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.page == 'takeaway') ? _c('div', {
    staticClass: "container masthead-container masthead-container-takeaway"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left"
  }, [_c('div', {
    staticClass: "masthead-inner"
  }, [_c('div', {
    staticClass: "masthead-image masthead-image-1"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'takeaway/' + _vm.takeaway.lockup.lockup_1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-image-2"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'takeaway/' + _vm.takeaway.lockup.lockup_2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-image-3"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'takeaway/' + _vm.takeaway.lockup.lockup_3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-text"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'takeaway/' + _vm.takeaway.lockup.text_img
    }
  })], 1)])])])]) : _vm._e(), _vm._v(" "), (_vm.page == 'projects') ? _c('div', {
    staticClass: "container masthead-container masthead-container-projects"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-10 col-lg-offset-1 text-left"
  }, [_c('div', {
    staticClass: "masthead-inner"
  }, [_c('div', {
    staticClass: "masthead-image masthead-image-1"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'projects/' + _vm.projects.lockup.lockup_1
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-image-2"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'projects/' + _vm.projects.lockup.lockup_2
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-image-3"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'projects/' + _vm.projects.lockup.lockup_3
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "masthead-image masthead-text"
  }, [_c('image-loader', {
    staticClass: "masthead-desktop",
    attrs: {
      "imgSrc": 'projects/' + _vm.projects.lockup.text_img
    }
  })], 1)])])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4abee213","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MastHead.vue
// module id = 143
// module chunks = 2